import axios from 'axios';

const axiosServer = axios.create({
  baseURL: process.env.API_BASE_URL || 'http://localhost:5001',
  timeout: 10000,
});

axiosServer.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('[axiosServer] Unauthorized - token may be invalid.');
    }
    return Promise.reject(error);
  }
);

export default axiosServer;